import React, {Component} from 'react';
import './CommandHistoryTab.css';
import CommandAPIs from '../../../../APIs/CommandAPIs';
import moment from 'moment';
import {intervalMap} from '../DeviceSettingsTab/DeviceSettingsTab';
import _ from 'lodash';
import { downloadCSV } from '../../../../Layouts/config/reports/advancedFuelReport/advancedFuelReport';
import EXECUTION_SUCCESS from'../../../../assets/svg/execution_success.svg'
import EXECUTION_FAILED from'../../../../assets/svg/execution_failed.svg'
import EXECUTION_INPROG from'../../../../assets/svg/execution_inprog.svg'
import EXECUTION_STARTED from'../../../../assets/svg/execution_started.svg'
import PICKEDUP_BY_SERVER from'../../../../assets/svg/picked_up_by_server.svg'
import REJECTED_BY_SERVER from'../../../../assets/svg/rejected_by_server.svg'
import SEND_BY_SERVER from'../../../../assets/svg/sent_by_server.svg';
import UNKNOWN_STATE from'../../../../assets/svg/unknown_state.svg'

let cmdExpansion = {
    'SET_AT4_BEACON_INTERVAL': 'Change beacon interval',
}

let duration = (duration) => {
    let seconds = parseInt(duration);
    if(seconds >= 3600) return moment.duration(seconds * 1000).asHours() + ' Hrs';
    else if(seconds >= 60) return moment.duration(seconds * 1000).asMinutes() + ' Min';
    else return moment.duration(seconds * 1000).asSeconds() + ' Sec';
}

let getcols = (r) => {
    let params = r.params || {};
    let extra = '';
    if(r.commandtype == 'SET_AT4_BEACON_INTERVAL') {
        let freq = params.beacon_frequency || '';
        if(freq) extra = (' to ' + duration(freq));
    }
    let cmd = cmdExpansion[r.commandtype] || r.commandtype;
    cmd = cmd + extra;
    return [
        cmd,
        r.deviceno,
        r.username,
        moment(r.executedat).format('DD-MMM-YYYY HH:mm:ss'),
    ]
}

let cols = [
    'Command',
    'Device id',
    'Executed by',
    'Executed at',
]

let levelZero = [
    {key: "cmdid", label: 'Cmd Id', width: '15%'},
    {key: "cmdtype", label: 'Cmd Type', width:'20%' },
    {key: "cmdsrc", label: 'Source', width:'15%'},
    {key: "createdby", label: 'Created By', width:'25%'},
    {key: "cmdTrgAt",label:'Trigger At',width:'25%'}
    // {key: "current_status", label: 'Status', width:'20%'},
    // {key: "time", label: 'Timestamp', width:'25%'}
]

let levelOne = [
    {key: "-", label: 'icon', width:'15%'},
    {key: "cmdstatus", label: 'Status', width:'50%'},
    {key: "updatedat", label: 'Updated At', width:'30%'}
]

let levelTwo = [
    // {key: "deviceid", label: 'Device id'},
    {key: "devstate", label: 'Device State'},

    {key: "gpstime", label: 'GPS Time'},
    {key: "ignstatus", label: 'Ing Status'},
    {key: "ischarging", label: 'Charging Status'},
    {key: "isimmobilized", label: 'Is Immobilized'},

    {key: "islocked", label: 'Is Locked'},
    {key: "lastcommtime", label: 'Last Com Time'},
    {key: "vehspeed", label: 'Vehicle Speed'},
    {key: "lat", label: 'Latitude'},
    {key: "lng", label: 'Longitude'},
]

class CommandHistoryTab extends Component {
    state = {
        history: [],
        lafHistory: [],
        busy: false,
        firstLoad: true,
        expandLevelOne: null,
        expandLevelTwo: null
    }
    lafPollingTimer = null; 
    componentDidMount() {
        window.addVehicleListener('settingspane', () => {
            this.setState({history: [],lafHistory: [], busy: true});
        })
       
        // if (this.props.isSettingsPaneActive) {
        //     this.loadVehicleHistory();
        // }
    }
    componentWillUnmount() {
        console.log(window.vehicleListener)
        if(window.vehicleListener)delete window.vehicleListener['settingspane'];

        if (this.lafPollingTimer) clearInterval(this.lafPollingTimer); 
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isSettingsPaneActive && !this.props.isSettingsPaneActive) {
            this.stopLafPolling();
        }
        if (!prevProps.isSettingsPaneActive && this.props.isSettingsPaneActive) {
            if (this.state.lafHistory.length > 0) {
                this.checkAndStartLafPolling(window.selectedVehicle);
            } else {
                this.loadVehicleHistory();
            }
        }
        if (this.props.ver !== prevProps.ver && this.props.isSettingsPaneActive) {
            this.loadVehicleHistory();
        }
    }
    
    stopLafPolling = () => {
        if (this.lafPollingTimer) {
            clearInterval(this.lafPollingTimer);
            this.lafPollingTimer = null;
        }
    };
    // componentWillReceiveProps(props) {
    //    // console.log(props);
    //     if(props.ver != this.props.ver) this.loadVehicleHistory()
    // };
    loadVehicleHistory(props = this.props) {
        if (!this.props.isSettingsPaneActive) return;
           // Show loader only if not already fetching data
           if (!this.state.busy) {
               this.setState({ busy: true });
           }
        // if (this.state.firstLoad) {
        //            this.setState({ busy: true });
        //        }
        let vehicle = window.selectedVehicle;
        CommandAPIs.getVehicleHistory({vehicleid:vehicle.vehicleid,vehicletype:vehicle.type}).then(rsp => {
            this.setState({history: rsp});
        });  
        if(vehicle && vehicle.devices &&vehicle.devices.TRACKER && vehicle.devices.TRACKER.devicetype && vehicle.devices.TRACKER.devicetype === 'laf') {
            let endtime = moment().unix() * 1000;
            let starttime = moment().subtract(15, 'days').unix() * 1000;
            let body = {
                vehicleno : vehicle.vehicleno,
                endtime : endtime,
                starttime: starttime,
            }
            CommandAPIs.getLafCmdHistory(body).then((resp) => {
                let data = resp || [];
            
                data.forEach(item => {
                    item.data = item.status || [];
                    item.cmdtype = item?.cmd?.mode 
                    ? `${item?.cmd?.type}_${item?.cmd?.mode}` 
                    : (item?.cmd?.type || "-");
            
                    // latest status
                    let latest = _.maxBy(item.status, "timestamp");
                    item.current_status = latest?.cmdstatus;
            
                    // trigger time
                    let trigger = item.status.find(
                        s => s.cmdstatus === "CMD_TRIGGERED_BY_USER"
                    );
            
                    item.cmdTrgAt = trigger?.timestamp;
            
                    // fallback timestamp for sorting
                    item.time =
                        item.cmdTrgAt ||
                        item.status?.[0]?.timestamp ||
                        0;
                });
            
                const sortedData = _.orderBy(data, ["time"], ["desc"]);
            
                console.log("sortedData", sortedData);
                this.setState({ lafHistory: sortedData, busy:false });
            
                // this.setState({ lafHistory: sortedData, busy:false }, () => {
                //     this.checkAndStartLafPolling(vehicle);
                // });
            })
            .catch((e) => {
                console.log("error")
                this.setState({busy:false})
            })
        
            
        }else {
            this.setState({busy:false})
        }
              
    }

    checkAndStartLafPolling = (vehicle) => {
        if (!this.props.isSettingsPaneActive) {
            return;
        }
        if (!this.state.lafHistory.length) {
            if (this.lafPollingTimer) {
                clearInterval(this.lafPollingTimer);
                this.lafPollingTimer = null;
            }
            return;
        }
    
        let latestTimestamp = this.state.lafHistory[0].time;
        if (!latestTimestamp) {
            if (this.lafPollingTimer) {
                clearInterval(this.lafPollingTimer);
                this.lafPollingTimer = null;
            }
            return;
        }
    
        const diffHours = moment().diff(moment(latestTimestamp), 'hours');
    
        if (diffHours <= 8) {
            if (this.lafPollingTimer) clearInterval(this.lafPollingTimer);
    
            this.lafPollingTimer = setInterval(() => {
                this.loadVehicleHistory();
            }, 10 * 1000);
        } else {
            if (this.lafPollingTimer) {
                clearInterval(this.lafPollingTimer);
                this.lafPollingTimer = null;
            }
        }
    };
    download = () => {
        let csv = cols.join(',') + '\n';
        csv += this.state.history.map(f => getcols(f).join(',')).join('\n');
        downloadCSV(csv, 'klelog');
    }

    lafDownload = () => {
        let csv_headers_array = [...levelZero, ...levelOne].map((data)=>data.key)
        let csv_row_array = [];
        for(let i in this.state.lafHistory){
                let data_arr = this.state.lafHistory[i].data.map((dataobj) => {
                        let row_arr = csv_headers_array.map((keyObj) => {
                                return this.parseData(this.state.lafHistory[i][keyObj] ? this.state.lafHistory[i][keyObj] : dataobj[keyObj], keyObj)
                        }).join(",");
                        
                        return row_arr;
                })
                
                csv_row_array.push(data_arr.join("\n")+"\n")
        }
        let csv = csv_headers_array.join(",")+"\n"+csv_row_array.join("\n")
        downloadCSV(csv, 'klelog');

    }
    bothDownload = () => {
        if(this.state.history[0].cmdid){
            this.downloadNewData()
        }else {
            this.download()
        }
        if(this.state.lafHistory.length) {
            this.lafDownload()
        }
        
        
    }

    // downloadNewData = () =>{
    //  let csv =  [...dataMap, ...expandedDataMap].map((data)=>data.key).join(",") + '\n'
    //  csv += this.state.history.map((data)=>{
    //     return [...dataMap, ...expandedDataMap].map((emap)=>{
    //        return  this.parseData(data[emap.key])
    //     }).join(',')
    //  }).join('\n')
    //  downloadCSV(csv, 'klelog');
    // }


    downloadNewData = () =>{
        let csv_headers_array = [...levelZero, ...levelOne, ...levelTwo].map((data)=>data.key)
        let csv_row_array = [];
        for(let i in this.state.history){
                let data_arr = this.state.history[i].data.map((dataobj) => {
                        let row_arr = csv_headers_array.map((keyObj) => {
                                return this.parseData(this.state.history[i][keyObj] ? this.state.history[i][keyObj] : dataobj[keyObj], keyObj)
                        }).join(",");
                        
                        return row_arr;
                })
                
                csv_row_array.push(data_arr.join("\n")+"\n")
        }
        let csv = csv_headers_array.join(",")+"\n"+csv_row_array.join("\n")
        downloadCSV(csv, 'klelog');
    }

       
    parseData = (data, key) =>{
        if(Number.isInteger(data) && data.toString().length>11){
            return moment(data).format('DD-MMM-YYYY HH:mm:ss')
        }else if( key == "vehspeed" || key == "lat" || key == "lng"){
             return data
        }
        else if(data == 0){
            return "False"
        }else if(data == 1){
            return "True"
        }else return data
    }

    expandOne = (index) =>{
        if(index == this.state.expandLevelOne ){
            this.setState({expandLevelOne: null})
        }else{
            this.setState({expandLevelOne: index})
        }
     }

     expandTwo = (index) =>{
        if(index == this.state.expandLevelTwo ){
            this.setState({expandLevelTwo: null})
        }else{
            this.setState({expandLevelTwo: index})
        }
     }
    getStatusIcon = (status) =>{
        switch (status) {
            case 'CMD_PICKED_UP_BY_SERVER':
                return <img src={PICKEDUP_BY_SERVER}></img>
            case 'CMD_REJECTED_BY_SERVER':
                return <img src={REJECTED_BY_SERVER}></img>
            case 'CMD_SENT_TO_DEVICE_BY_SERVER':
                return <img src={SEND_BY_SERVER}></img>
            case 'DEVICE_CMD_EXECUTION_FAILED':
                return <img src={EXECUTION_FAILED}></img>
            case 'DEVICE_CMD_EXECUTION_INPROG':
                return <img src={EXECUTION_INPROG}></img>
            case 'DEVICE_CMD_EXECUTION_STARTED':
                return <img src={EXECUTION_STARTED}></img>
            case 'DEVICE_CMD_EXECUTION_SUCCESS':
                return <img src={EXECUTION_SUCCESS}></img>
            case 'DEVICE_CMD_EXECUTION_UNKNOWN_STATE':
                return <img src={UNKNOWN_STATE}></img>
            default:
                return <img src={UNKNOWN_STATE}></img>
          }
    }

    render() {
        const { busy } = this.state;
        return (
            <div className={'cht-con' + (busy ? ' busy' : '')}>
                {!this.state.busy && this.state.history.length == 0 && this.state.lafHistory.length == 0 && <div className="ds-box-empty">No history</div>}
                {this.state.history.length > 0 && !this.state.history[0].cmdid && <div className="cht-bod"><table>
                    <thead>
                        <tr>
                            {cols.map((c, i) => <th key={i}>{c}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.history.map((r, i) => {
                            let cols = getcols(r);
                            return (
                                <tr key={i}>
                                    {cols.map((f, i) => <td key={i}>{f}</td>)}
                                </tr>
                            )
                        })}
                    </tbody>
                </table></div>} 

                {this.state.history.length > 0 && this.state.history[0].cmdid && <div className="cht-bod">
                    <div className='custom-table'>
                        {this.state.history.map((item, index)=>{
                           return  <div className='table-row-container' key={index}>
                                        <div className='table-row' onClick={()=>this.expandOne(index)}>
                                            { levelZero.map((row, index)=>{ 
                                              

                                              return (<div style={{width: row.width}} className='table-data' key={index}>
                                                        <div className='data-heading'>
                                                            <div className='heading'>{row.label} </div>
                                                        </div>
                                                        <div className='row-data'>{row.key == "time"?moment(item[row.key]).format('DD-MMM-YYYY HH:mm:ss'): item[row.key]}</div>
                                                    </div>)
                                             })
                                             }
                                        </div>
                                        {this.state.expandLevelOne == index && 
                                                item.data.map((lOneData, lOneIndex)=>{
                                                  return <div className='level-one-container' key={lOneIndex}>
                                                        <div className='table-row' onClick={()=>this.expandTwo( index.toString() + lOneIndex.toString())}>
                                                            {
                                                                levelOne.map((lOneKey, lOneIndex)=>{
                                                                    return (lOneKey.label == 'icon'?<div style={{width: lOneKey.width}} className='icon-container'>{this.getStatusIcon(lOneData.cmdstatus)}</div>:
                                                                        <div style={{width: lOneKey.width}} className='table-data' key={lOneIndex}>
                                                                            <div className='data-heading'>
                                                                                <div className='heading'>{lOneKey.label} </div>
                                                                            </div>
                                                                            <div className='row-data'>{lOneKey.key == "updatedat"?moment(lOneData[lOneKey.key]).format('DD-MMM-YYYY HH:mm:ss'): lOneData[lOneKey.key]}</div>
                                                                        </div> 
                                                                    )
                                                                })
                                                            }
                                                        </div>

                                                        {this.state.expandLevelTwo == index.toString()+lOneIndex.toString() && 
                                                            <div className='table-expanded-row' >
                                                                {levelTwo.map((lTwoMap, lTwoIndex)=>{ 
                                                                    return( 
                                                                            <div className='expanded-data' key={lTwoIndex}>
                                                                                <div className='data-key'>{lTwoMap.label}</div>
                                                                                <div className='data-value'>{this.parseData(lOneData[lTwoMap.key],lTwoMap.key )}</div>
                                                                            </div>     
                                                                    )})}
                                                            </div>
                                                        } 

                                                    </div>
                                                })
                                             }
                                    </div>
                        })}

                   </div> 
                </div>} 
                {this.state.lafHistory.length > 0 && this.state.lafHistory[0].cmdid && <div className="cht-bod">
                    <div className='custom-table'>
                        {this.state.lafHistory.map((item, index)=>{
                           return  <div className='table-row-container' key={index}>
                                        <div className='table-row' onClick={()=>this.expandOne(index)}>
                                            { levelZero.map((row, index)=>{ 
                                              return (<div style={{width: row.width}} className='table-data' key={index}>
                                                        <div className='data-heading'>
                                                            <div className='heading'>{row.label} </div>
                                                        </div>
                                                        <div className='row-data'>{row.key == "time" || row.key == "cmdTrgAt"   ? moment(item[row.key]).format('DD-MMM-YYYY HH:mm:ss'): item[row.key]}</div>
                                                    </div>)
                                             })
                                             }
                                        </div>
                                        {this.state.expandLevelOne == index && 
                                                item.data.map((lOneData, lOneIndex)=>{
                                                  return <div className='level-one-container' key={lOneIndex}>
                                                        <div className='table-row' onClick={()=>this.expandTwo( index.toString() + lOneIndex.toString())}>
                                                            {
                                                                levelOne.map((lOneKey, lOneIndex)=>{
                                                                    return (lOneKey.label == 'icon'?<div style={{width: lOneKey.width}} className='icon-container'>{this.getStatusIcon(lOneData.cmdstatus)}</div>:
                                                                        <div style={{width: lOneKey.width}} className='table-data' key={lOneIndex}>
                                                                            <div className='data-heading'>
                                                                                <div className='heading'>{lOneKey.label} </div>
                                                                            </div>
                                                                            <div className='row-data'>{lOneKey.key == "updatedat"?moment(lOneData["timestamp"]).format('DD-MMM-YYYY HH:mm:ss'): lOneData[lOneKey.key]}</div>
                                                                        </div> 
                                                                    )
                                                                })
                                                            }
                                                        </div>

                                                        {/* {this.state.expandLevelTwo == index.toString()+lOneIndex.toString() && 
                                                            <div className='table-expanded-row' >
                                                                {levelTwo.map((lTwoMap, lTwoIndex)=>{ 
                                                                    return( 
                                                                            <div className='expanded-data' key={lTwoIndex}>
                                                                                <div className='data-key'>{lTwoMap.label}</div>
                                                                                <div className='data-value'>{this.parseData(lOneData[lTwoMap.key],lTwoMap.key )}</div>
                                                                            </div>     
                                                                    )})}
                                                            </div>
                                                        }  */}

                                                    </div>
                                                })
                                             }
                                    </div>
                        })}

                   </div> 
                </div>}


                {this.state.history.length > 0 || this.state.lafHistory.length > 0 ?  <div className="cht-fut">
                    <div className="spd-btn">
                        <div><button onClick={this.state.lafHistory.length && this.state.history.length ? this.bothDownload : this.state.lafHistory.length ? this.lafDownload : this.state.history.length && this.state.history[0].cmdid ? this.downloadNewData:this.download}><i className="fa fa-download"></i> Download</button></div>
                    </div>
                </div> : null}
                {/* {!this.state.busy && this.state.history.map((r, i) => {
                    let params = r.params || {};
                    return (
                        <div className="cht-bx" key={i}>
                            <div className="chtb-ac">
                                <div className="chtb-ah">{cmdExpansion[r.commandtype]}</div>
                                <div className="chtb-ar">
                                    <div className="chtb-rl">Device ID: {r.deviceno}</div>
                                    <div className="chtb-rr">{params.beacon_frequency ? 'Beacon frequency: ' + params.beacon_frequency : ''}</div>
                                </div>
                                <div className="chtb-ar lw">
                                    <div className="chtb-rl">Executed by: {r.username}</div>
                                    <div className="chtb-rr">{moment(r.executedat).format('DD-MMM-YYYY HH:mm')}</div>
                                </div>
                            </div>
                        </div>
                    )
                })} */}
                {this.state.busy  && [<div className="ld-bx" key={0}>
                    <div className="ldbr g"></div>
                    <div className="ldbr b"></div>
                    <div className="ldbr"></div>
                </div>,
                <div className="ld-bx" key={1}>
                    <div className="ldbr b"></div>
                    <div className="ldbr g"></div>
                    <div className="ldbr"></div>
                </div>,
                <div className="ld-bx" key={2}>
                    <div className="ldbr b"></div>
                    <div className="ldbr"></div>
                    <div className="ldbr g"></div>
                </div>,
                <div className="ld-bx" key={3}>
                    <div className="ldbr b"></div>
                    <div className="ldbr g"></div>
                    <div className="ldbr"></div>
                </div>]}
            </div>
        );
    }
}

export default CommandHistoryTab;